import React from 'react';
import {
  StyledSection,
  StyledFlex,
  StyledTextPairing,
  StyledGridContainer,
  StyledCardWrapper,
} from '@sections/registry/ShopSection/ShopSection.styles';
import { RecommendProducts } from '@sections/shared/GridView';
import { CurationCard, OneRegistryCard, RecommendedProducts, UniversalSearchCard } from './components';
import { useTranslation } from 'react-i18next';

export const ShopSection: React.FC<{ products: RecommendProducts }> = ({ products }) => {
  const { t } = useTranslation('registry');
  const shopSection = t('shopSection');

  return (
    <StyledSection as="section" id="RegistryShopSection" paddingTop={5}>
      <StyledFlex margin={'auto'} flexDirection="column" paddingX={[3, 0]}>
        <StyledTextPairing
          alignment="center"
          title={shopSection.title}
          titleColor="mono1"
          titleTagName="h2"
          titleVariant="hed56"
          body={shopSection.subTitle}
          bodyColor="mono1"
          bodyVariant="dek20"
          marginBottom={7}
        />
      </StyledFlex>
      <StyledGridContainer>
        <RecommendedProducts products={products} />
        <StyledCardWrapper>
          <OneRegistryCard />
          <CurationCard />
          <UniversalSearchCard />
        </StyledCardWrapper>
      </StyledGridContainer>
    </StyledSection>
  );
};
